import { Input, Form, Button, Select } from 'antd';
import DownSvg from 'assets/svg/Down';
import { CustomSelect } from 'components/molecules/PricingSimulator/DimSection';
import { TPODataContext } from 'contexts/TPOContext';
import _, { values } from 'lodash';
import { Dispatch, FC, useContext, useEffect, useMemo, useState } from 'react';
import { OfferMethod, OfferTypeUnit } from 'types/tradePromoOptimization';
import dayjs, { Dayjs } from 'dayjs';
import { FormInstance } from 'antd/es/form';

//updating antd config from moment to dayjs
//antd uses moment js by default for reading value
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import { UserContext } from 'contexts/ConfigContext';
import { generateEventName, getConfig } from 'utils/helperMethods';
//updated component that uses dayjs instead of moment
const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

type Props = {
    form: FormInstance<any>;
    disabledEvent: boolean;
};

const EventInfo: FC<Props> = ({ form, disabledEvent }) => {
    // const [offerVariables, setOfferVariables] = useState({});
    // const [triggerOfferApi, setTriggerOfferApi] = useState(false);
    //context
    const { appConfig } = useContext(UserContext);

    const { dimensionConfigData, selectedPlanInfo } = useContext(TPODataContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const tradePromoOptimizationConfig = getConfig('tradePromoOptimization', appConfig);
    const dateFormat = commonConfig?.dateFormat;
    const planYear = selectedPlanInfo?.planYear;

    //this is used to re render the form
    //by default antd forms do not cause a re render
    // const startDateValue = Form.useWatch(['CRAStartDate'], form);
    // const endDateValue = Form.useWatch(['CRAEndDate'], form);

    // const offerMethodValue = Form.useWatch(['offerMethod'], form);
    // const offerTypeValue = Form.useWatch(['offerType'], form);
    // const offerValue = Form.useWatch(['offer'], form);
    // const offerTypeUnitValue = Form.useWatch(['offerTypeUnit'], form);

    //trigger offer api, when offer method is changing
    // const { loading: offerLoading, data: offerList } = useFetchOfferData({
    //     method: 'post',
    //     queryKey: ['tpo-fetch-offer-data', offerVariables],
    //     url: tradePromoOptimizationUrls.getOfferDataUrl,
    //     variables: offerVariables,
    //     queryConfig: {
    //         enabled: !_.isEmpty(offerVariables) && triggerOfferApi,
    //     },
    // });
    // //generate event name
    // useEffect(() => {
    //     if (offerValue && startDateValue) {
    //         //generate event name
    //         const name = generateEventName(
    //             offerValue,
    //             offerMethodValue,
    //             startDateValue,
    //             offerTypeValue,
    //             offerTypeUnitValue,
    //         );
    //         form.setFieldValue('name', name);
    //     } else {
    //         form.setFieldValue('name', undefined);
    //     }
    // }, [offerValue, offerTypeUnitValue, startDateValue]);

    //set offer type ,1st item as default when offer method is changed
    // useEffect(() => {
    //     if (offerMethodValue === 'manual') {
    //         form.setFieldValue('offerType', manualTypeList?.[0]?.value);
    //     }
    // }, [offerMethodValue]);

    //reset offer field offer type is changed
    // useEffect(() => {
    //     form.setFieldValue('offer', undefined);
    // }, [offerTypeValue]);

    //set offer variables when offer popup is opened
    // useEffect(() => {
    //     if (!triggerOfferApi || offerMethodValue === 'manual') {
    //         setOfferVariables({}); //set offer variables as empty when popup is closed or manual is selected
    //     } else if (offerMethodValue) {
    //         const attrNames = dimensionConfigData?.eventDim1NestedAttribute?.key
    //             ? form.getFieldValue('selectedDim1NestedValues')
    //             : form.getFieldValue('selectedDim1Values');
    //         setOfferVariables({
    //             selected_attributes: attrNames?.map((item: any) => item?.value) ?? [],
    //             offer_type: offerMethodValue,
    //             limit: tradePromoOptimizationConfig?.offerDataDropdownLimit,
    //             offset: 0,
    //         });
    //     }
    // }, [triggerOfferApi]);

    // const selectedOfferTypeItem = useMemo(() => {
    //     return manualTypeList.find((item) => item?.value === offerTypeValue);
    // }, [offerTypeValue]);

    //calculate duration based on end date and start date
    // useEffect(() => {
    //     const startDate = form.getFieldValue('CRAStartDate');
    //     const endDate = form.getFieldValue('CRAEndDate');
    //     if (startDate && endDate) {
    //         const duration = dayjs(endDate).startOf('day').diff(dayjs(startDate).startOf('day'), 'day');
    //         form.setFieldValue('CRADuration', duration);
    //     }
    // }, [startDateValue, endDateValue]);

    //check if start date is less than end date
    const validateStartDate = (_: any, value: Dayjs) => {
        const endDate = form.getFieldValue('CRAEndDate') as Dayjs;
        if (!value || !endDate || value.isBefore(endDate)) {
            return Promise.resolve();
        }
        return Promise.reject(new Error('Start date must be earlier than end date.'));
    };

    //check if end date is greater than start date
    const validateEndDate = (_: any, value: Dayjs) => {
        const startDate = form.getFieldValue('CRAStartDate') as Dayjs;
        if (!value || !startDate || value.isAfter(startDate)) {
            return Promise.resolve();
        }
        return Promise.reject(new Error('End date must be later than start date.'));
    };

    // const isCombinationOffer = selectedOfferTypeItem?.value === 'combination_offer';

    // const offerLabel = `${
    //     selectedOfferTypeItem ? (isCombinationOffer ? 'Buy & Get' : selectedOfferTypeItem?.label) : 'Offer'
    // }`;

    return (
        <div className="w-full  flex flex-col flex-grow gap-3 border border-backgroundGreyAlt6 rounded p-3 bg-white ">
            <div className="flex flex-col h-full gap-6 bg-backgroundGreyAlt6 p-3 pr-4 rounded overflow-y-scroll">
                <div className="flex items-center gap-2 w-full">
                    <span className="ant-col ant-col-8 text-right pr-6 font-bold">Levers</span>
                    <span className="ant-col ant-col-16 text-center font-bold">Modified</span>
                </div>
                <Form
                    disabled={disabledEvent}
                    form={form}
                    name="event"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                >
                    <Form.Item
                        label="Event Name"
                        name="name"
                        rules={[{ required: true, message: 'Please enter Event Name' }]}
                    >
                        <Input className="font-xs" type="text" style={{ borderRadius: 6 }} placeholder="Event Name" />
                    </Form.Item>
                    {/* <Form.Item
                        normalize={(value) => {
                            //reset offer type when offer method is changed
                            if (value === 'manual') {
                                form.setFieldValue('offerType', manualTypeList?.[0]?.value);
                                form.setFieldValue('offerTypeUnit', 'abs');
                            }
                            return value;
                        }}
                        label="Offer Method"
                        name="offerMethod"
                        rules={[{ required: true, message: 'Please select an offer method' }]}
                    >
                        <CustomSelect
                            placeholder="Offer Method"
                            className="dropdown-height"
                            loading={false}
                            options={offerMethodDropdownOptions}
                        />
                    </Form.Item> */}
                    {/* {offerMethodValue === 'manual' && (
                        <Form.Item
                            normalize={(value) => {
                                //reset offer field offer type is changed
                                form.setFieldValue('offer', undefined);
                                return value;
                            }}
                            dependencies={['offer']}
                            label="Manual Type"
                            name="offerType"
                            rules={[{ required: true, message: 'Please select an offer type' }]}
                        >
                            <CustomSelect
                                placeholder="Offer Method"
                                className="dropdown-height"
                                loading={false}
                                options={manualTypeList}
                            />
                        </Form.Item>
                    )} */}

                    {/* <Form.Item
                        normalize={
                            isCombinationOffer
                                ? (value) => {
                                      //return the latest updated offer which is an array
                                      return form.getFieldValue('offer');
                                  }
                                : undefined
                        }
                        label={offerLabel}
                        name="offer"
                        rules={[
                            { required: true, message: 'Please select an offer' },
                            {
                                validateTrigger: 'onBlur',
                                validator: (_, value) => {
                                    if (
                                        (isCombinationOffer && Array.isArray(value) && value?.[0] && !value?.[1]) ||
                                        (value?.[1] && !value?.[0])
                                    ) {
                                        return Promise.reject(new Error('Please enter both Buy and Get'));
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                    >
                        {offerMethodValue === 'manual' ? (
                            isCombinationOffer ? (
                                <div className="flex items-center gap-4">
                                    <Input
                                        placeholder={'Buy'}
                                        className="font-xs"
                                        type="number"
                                        style={{ borderRadius: 6 }}
                                        value={offerValue?.[0]}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const currentOffer = offerValue?.[1] ?? ''; // Get the current value
                                            form.setFieldValue('offer', [value, currentOffer]); // Update 'Buy' value
                                        }}
                                    />
                                    -
                                    <Input
                                        placeholder={'Get'}
                                        className="font-xs"
                                        type="number"
                                        style={{ borderRadius: 6 }}
                                        value={offerValue?.[1]}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const currentOffer = offerValue?.[0] ?? ''; // Get the current value
                                            form.setFieldValue('offer', [currentOffer, value]); // Update 'Buy' value
                                        }}
                                    />
                                    <Form.Item
                                        className={`${
                                            disabledEvent ? 'cursor-not-allowed' : 'cursor-pointer'
                                        }  !m-0 customInputOffer w-full`}
                                        name="offerTypeUnit"
                                    >
                                        <AbsPercentageSuffix
                                            disabled={disabledEvent}
                                            form={form}
                                            offerTypeUnitValue={offerTypeUnitValue}
                                        />
                                    </Form.Item>
                                </div>
                            ) : (
                                <Input
                                    placeholder={offerLabel}
                                    className="font-xs"
                                    type="number"
                                    suffix={
                                        <Form.Item
                                            className={`${
                                                !disabledEvent ? 'cursor-not-allowed' : 'cursor-pointer'
                                            }  !m-0 customInputOffer`}
                                            name="offerTypeUnit"
                                        >
                                            <AbsPercentageSuffix
                                                disabled={disabledEvent}
                                                form={form}
                                                offerTypeUnitValue={offerTypeUnitValue}
                                            />
                                        </Form.Item>
                                    }
                                    style={{ borderRadius: 6 }}
                                />
                            )
                        ) : (
                            <OfferDropdown
                                disabled={disabledEvent}
                                onDropdownVisibleChange={(open) => {
                                    if (open) setTriggerOfferApi(true);
                                    else setTriggerOfferApi(false);
                                }}
                                data={offerList}
                                placeholder={offerLabel}
                                className="dropdown-height w-full offer-dropdown"
                                loading={offerLoading}
                                // options={offerMethodDropdownOptions}
                            />
                        )}
                    </Form.Item> */}
                    <Form.Item
                        dependencies={['CRAEndDate']}
                        label="Event Start Date"
                        name="CRAStartDate"
                        rules={[
                            // { required: true, message: 'Please enter CRA Start Date' },
                            { validator: validateStartDate },
                        ]}
                    >
                        <DatePicker
                            allowClear={false}
                            disabledDate={(date) => {
                                const yearCondition = date.year() !== planYear; //disable all dates other than plan year
                                const dayCondition = date.isBefore(dayjs(), 'day'); //disable dates before current date
                                return yearCondition || dayCondition;
                            }}
                            disabled
                            defaultPickerValue={dayjs(`${planYear}-${dayjs().format('MM')}-01`)}
                            format={dateFormat}
                            style={{ width: '100%', borderRadius: 6 }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Event End Date"
                        name="CRAEndDate"
                        rules={[
                            { validator: validateEndDate },
                            // { required: true, message: 'Please enter CRA End Date' },
                        ]}
                    >
                        <DatePicker
                            disabled
                            disabledDate={(date) => {
                                //    const yearCondition = date.year() !== planYear; //disable all dates other than plan year
                                const dayBeforeCondition = date.isBefore(dayjs(), 'day'); //disable dates before current date
                                const dayAfterCondition = date.isAfter(dayjs(`${(planYear ?? 0) + 1}-01-31`)); //allow end dates to go till jan end of nest year
                                return dayAfterCondition || dayBeforeCondition;
                            }}
                            defaultPickerValue={dayjs(`${planYear}-${dayjs().format('MM')}-01`)}
                            allowClear={false}
                            format={dateFormat}
                            style={{ width: '100%', borderRadius: 6 }}
                        />
                    </Form.Item>
                    {/* <Form.Item label="CRA Duration" name="CRADuration">
                        <Input
                            readOnly
                            className="font-xs"
                            type="number"
                            style={{ borderRadius: 6 }}
                            placeholder="CRA Duration"
                        />
                    </Form.Item> */}
                    <Form.Item
                        label="Display ACV (%)"
                        name="displayACV"
                        // rules={[{ required: true, message: 'Please enter Display ACV' }]}
                    >
                        <Input
                            className="font-xs"
                            type="number"
                            style={{ borderRadius: 6 }}
                            placeholder="Display ACV"
                        />
                    </Form.Item>
                    <Form.Item
                        label="Feature ACV (%)"
                        name="featureACV"
                        //  rules={[{ required: true, message: 'Please enter Feature ACV' }]}
                    >
                        <Input
                            className="font-xs"
                            type="number"
                            style={{ borderRadius: 6 }}
                            placeholder="Feature ACV"
                        />
                    </Form.Item>
                    {/* <Form.Item
                        label="New Status"
                        name="newStatus"
                        //  rules={[{ required: true, message: 'Please enter new Status' }]}
                    >
                        <Input
                            className="font-xs"
                            type="text"
                            style={{ borderRadius: 6 }}
                            placeholder="enter new Status"
                        />
                    </Form.Item> */}
                    {/* <Form.Item
                        label="Contract"
                        name="contract"
                        //  rules={[{ required: true, message: 'Please enter Contract' }]}
                    >
                        <Input className="font-xs" type="text" style={{ borderRadius: 6 }} placeholder="Contract" />
                    </Form.Item> */}
                    {/* <Form.Item
                        label="Par"
                        name="par"
                        // rules={[{ required: true, message: 'Please enter Par' }]}
                    >
                        <Input className="font-xs" type="text" style={{ borderRadius: 6 }} placeholder="enter Par" />
                    </Form.Item>
                    <Form.Item
                        className="ant-custom-form-label"
                        label={
                            <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Custom Promo Grouping</span>
                        }
                        name="promoGrouping"
                        //  rules={[{ required: true, message: 'Please enter custom Promo Grouping' }]}
                    >
                        <Input
                            className="font-xs"
                            type="text"
                            style={{ borderRadius: 6 }}
                            placeholder="enter custom Promo Grouping"
                        />
                    </Form.Item> */}
                </Form>
            </div>
        </div>
    );
};

export default EventInfo;

const AbsPercentageSuffix = ({
    form,
    offerTypeUnitValue,
    disabled,
}: {
    form: FormInstance<any>;
    offerTypeUnitValue: OfferTypeUnit;
    disabled: boolean;
}) => {
    return (
        <>
            <span
                onClick={() => {
                    if (disabled) return;
                    form.setFieldValue('offerTypeUnit', 'abs');
                }}
                className={`mr-2 ${offerTypeUnitValue === 'abs' ? 'text-purpleFont font-bold' : 'text-promoColour'}`}
            >
                Abs
            </span>
            <span
                onClick={() => {
                    if (disabled) return;
                    form.setFieldValue('offerTypeUnit', '%');
                }}
                className={`${offerTypeUnitValue === '%' ? 'text-purpleFont font-bold' : 'text-promoColour'}`}
            >
                %
            </span>
        </>
    );
};
